import { SET_ACTIVE_ARTICLE, ARTICLE_LIST, UPDATE_ARTICLE } from "../constants";
import { appLoading } from "./appActions";
import { DB } from "../firebase";

export const getArticle = (articleId) => (dispatch, getState) => {
  const state = getState();
  const { articleList } = state.articles;
  if( !articleList ) return;
  
  const articleDetail = articleList.find((art) => art.id === articleId);
  if (!articleDetail) return;
  dispatch({ type: SET_ACTIVE_ARTICLE, payload: articleDetail });
};

export const clearArticleDetail = () => {
  return { type: SET_ACTIVE_ARTICLE, payload: null };
};

export const getArticleList = () => (dispatch) => {
  DB.collection("articles")
    .get()
    .then((result) => {
      result = result.docs.map((r) => {
        const id = r.ref.id;
        return { ...r.data(), id };
      });
      dispatch({ type: ARTICLE_LIST, payload: result });
    });
};

export const updateLocalArticle = (article) => ({
  type: UPDATE_ARTICLE,
  payload: article,
});

export const updateArticleData = (articleData) => (dispatch) => new Promise(async (resolve) => {
  dispatch(appLoading(true));
  await DB.collection("articles").doc(articleData.id).set(articleData);
  dispatch(appLoading(false));
  dispatch({ type: "changedDataHandledByListenerAlready" });
  return resolve(true);
});

export const deleteArticle = (articleId) => (dispatch) =>
  new Promise((resolve) => {
    dispatch(appLoading(true));
    DB.collection("articles")
      .doc(articleId)
      .delete()
      .then(() => {
        console.log("Document successfully deleted!");
      })
      .catch((error) => {
        console.log("Error removing document: ", error);
      })
      .finally(() => {
        dispatch(getArticleList());
        dispatch(appLoading(false));
        resolve(true);
      });
  });



// WEBPACK FOOTER //
// ./src/actions/articlesActions.js